import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { number } from 'echarts';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { SseService } from 'src/app/services/SseService';
import { BrokerService } from 'src/app/services/broker.services';
import { RastreadorService } from 'src/app/services/rastreador.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-estudio-earning',
  templateUrl: './estudio-earning.component.html',
  styleUrl: './estudio-earning.component.scss'
})
export class EstudioEarningComponent implements OnInit, OnDestroy, OnChanges {

  private subCompania = new Subscription;
  private subIdNectumSeries: Subscription;
  private subDataEarning: Subscription;
  public companiaSeleccionada: any;
  public companiaCargada: any;
  public companiaData = new CdkTableVirtualScrollDataSource<any>;
  public filaSeleccionada='Sin Data';
  panelOpenState = false;
  colPanelOpen = false;
  expandirColPanel() { this.colPanelOpen = true; }
  contraerColPanel() { this.colPanelOpen = false; }
  public diasHabiles: boolean =false;
  public loading:boolean;
  public dias: number = 7;
  public idNectumSeries=0;
  public licencia:string;
  public url = 'rastreador/actualizarComentario';
  public comentarios: any[];
  @Input() selectedTab: number = 0;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) earning!: CdkVirtualScrollViewport;


  tableColumns : TableColmuns []=[
    { id: 'comentario', name: 'Comentario', isShow: true, isDate: false, isNumber: false, isString: true },
    {id: 'fechaAnterior', name:'F.Pre', isShow: true, isDate: true, isNumber: false, isString: false},
    {id: 'valorFinHoraInicioPre', name:'V.F.Pre', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'volatilidadAnterior', name:'Vol.F.Pre', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'rangoAnterior', name:'%Pre', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'variacionAnteriorMayor', name:'M.D.%Pre',isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'fechaVariacionAnteriorMayor', name:'F.M.D.%Pre', isShow: true, isDate: true, isNumber: false, isString: false},
    {id: 'valorMayorMenorFMPre', name:'V.M.D.%Pres', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'volatilidadFMPre', name:'Vol F.M.D.Pre', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'valorVolatilidad', name:'Vol F. Evento', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'fechaExcelHoraInicio', name:'F. Eventoo', isShow: true, isDate: true, isNumber: false, isString: false},
    {id: 'valorFinHoraFinPre', name:'V.F. Evento', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'fechaVariacionPosteriorMayor', name:'F.M.D.%Pos', isShow: false, isDate: true, isNumber: false, isString: false},
    {id: 'variacionPosteriorMayor', name:'M.D.%Pos', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'volatilidadFMPos', name:'Vol F.M.D.Pos',isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'valorMayorMenorFMPos', name:'V.M.D.%Pos', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'rangoPosterior', name:'%Pos', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'volatilidadPosterior', name:'Vol F.%Pos', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'valorFinHoraFinPos', name:'V.F.Pos', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'fechaPosterior', name:'F.Pos', isShow: false, isDate: true, isNumber: false, isString: false},
  ]

   displayedColumns: string[] = ['comentario','fechaAnterior', 'valorFinHoraInicioPre','volatilidadAnterior','rangoAnterior','variacionAnteriorMayor',
                                'fechaVariacionAnteriorMayor','valorMayorMenorFMPre','volatilidadFMPre','valorVolatilidad','fechaExcelHoraInicio',
/*                                 'valorFinHoraFinPre','fechaVariacionPosteriorMayor','variacionPosteriorMayor','volatilidadFMPos','valorMayorMenorFMPos',
                                'rangoPosterior','volatilidadPosterior','valorFinHoraFinPos','fechaPosterior' */
   ];
  theme: string;


  constructor(private _sseService: SseService,
              private _httpclient: HttpClient,
              private cdr: ChangeDetectorRef,
              private _rastreadorService: RastreadorService,
              private _coockieService: CookieService,
              private toastr: ToastrService,
  ){
  
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("DSDE ESTUDIO EARNING selectedTab:", this.selectedTab)
    if(this.selectedTab == 1){
      this.actualizarViewport();
    }
  }

  ngOnDestroy(): void {
    this.subCompania.unsubscribe();
    this.subIdNectumSeries.unsubscribe();
    this.subDataEarning.unsubscribe();
  }

  ngOnInit() {
    this.theme = this._coockieService.get('theme');
    this.licencia=this._coockieService.get('auth_token');
    this.subCompania = this._rastreadorService.valCompaniaSelec$.subscribe({
      next: (data: any)=>{
        this.companiaSeleccionada=data;
        if(this.companiaSeleccionada.nombre){
          this.companiaSeleccionada.nombre =  this.companiaSeleccionada.nombre.replace(/^✔\s*/, '');
          //console.log("DESDE EARNING : ", this.companiaSeleccionada);//nombre
          this.cargarComentarios();
        }

      }
    });
    this.subIdNectumSeries = this._rastreadorService.valIdNectumSeries$.subscribe({
      next: (data: any)=>{
        this.idNectumSeries = data;
        console.log("esto llego a llos earnig: ", data);  
      }
    });
    this.subDataEarning = this._rastreadorService.valDataEarning$.subscribe({
      next: (data: any)=>{
        this.companiaData = new CdkTableVirtualScrollDataSource<any>();
        this.companiaData.data=data;
        console.log("FUNCION GANANCIA: ", this.companiaData.data);
      }
    });

  }

  funcionaGanancias(){
    console.log("funcion Ganancias");
    if(this.companiaSeleccionada.nombre){
      //this.companiaData = new CdkTableVirtualScrollDataSource<any>();
      this.loading=true;
      let endpoint2= 'rastreador/calcularFechas?idNectum='+this.companiaSeleccionada.idNectum+'&idNectumSerie='+this.idNectumSeries+'&diasEvaluar='+this.dias+'&iso='+this.companiaSeleccionada.nombre+'&diasHabiles='+this.diasHabiles+'&licencia='+this.licencia;
      this._sseService.apiGetNew(endpoint2).subscribe({
        next: (data: any)=>{
          const nuevoArray = data.map((obj: any) => {
            let fecha= this.formtearFecha(obj.fechaExcelHoraInicio)
            return {
              ...obj,        
              id: fecha +':'+ this.companiaSeleccionada.idNectum 
            };
          });
          //console.log(nuevoArray);
          const arrayIdComentario = nuevoArray.map((obj: { id: any; }) => {
            const comentarioEncontrado = this.comentarios.find((com: { id: any; }) => com.id === obj.id);
            return {
              ...obj,
              comentario: comentarioEncontrado ? comentarioEncontrado.comentario : null
            };
          });
          this.companiaData.data = arrayIdComentario;
          this._rastreadorService.updateDataearning(arrayIdComentario);
          this.companiaCargada = this.companiaSeleccionada.nombre;
          this.loading=false;
          this.actualizarViewport();
          this.cdr.detectChanges();
        }
      });
    } else {
      this.toastr.error('Debe seleccionar una compañia.', 'Error', { timeOut: 4000, positionClass: 'toast-top-center' });
    }
  }
  cargarComentarios(){
    let urlComentario ='rastreador/listacomentarios';
    let data = { idnectum:  this.companiaSeleccionada.idNectum  }
    this._sseService.apiPostNew(urlComentario, data, this.licencia).subscribe({
      next: (data: any)=>{
        console.log(data);
        this.comentarios = data;
      }
    })
  }
  toggleColumnVisibility(id: any) {
    const column = this.tableColumns.find(col => col.id === id);
    if (column) {
      column.isShow = !column.isShow;
      this.displayedColumns = this.tableColumns.filter(col => col.isShow).map(col => col.id);
    }
  }

  selectRow(fila: any){

  }
  actualizarViewport(){
    console.log("actualizarViewportactualizarViewport");
    this.earning.checkViewportSize();
    this.earning.checkViewportSize();
  }

  editComentario(row: any){
  
    console.log(" this.idNectumSeries ", this.idNectumSeries );
    console.log("row row", row);
    if(row.comentario){
      let fecha = this.formtearFecha(row.fechaExcelHoraInicio);
      let datajson = {
        id : fecha +':'+ this.companiaSeleccionada.idNectum,
        comentario: row.comentario
      }
      console.log("if(row.comentario){ ",datajson );
      // si datajson.id no existe en this.comentarios, lo agrega si existe lo actualiza
      const index = this.comentarios.findIndex(com => com.id === datajson.id);
      if (index !== -1) {
        // Actualizar el comentario existente
        this.comentarios[index].comentario = datajson.comentario;
      } else {
        // Agregar un nuevo comentario
        this.comentarios.push(datajson);
      }

      this._sseService.apiPostNew(this.url, datajson, this.licencia).subscribe({
        next: (data: any)=>{
          if(data){
          //  this.funcionaGanancias();
          }
        }
      })
    }
  }

  formtearFecha(isoDate: any) {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses empiezan en 0
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  }

}
